export default {
  WATCH: 2,
  KIOSK_USB: 3,
  KIOSK_AUDIO_JACK: 4,
  ORDER_ONLY: 5,
  FIREBOARD: 6,
  PAYMENT_USB: 7,
  PAYMENT_AUDIO_JACK: 8,
  TCP_IP_PRINTER: 9,
  TABLE_TOP_USB: 10,
  TABLE_TOP_AUDIO_JACK: 11,
  TABLE_RESERVATION: 12,
  PRINT_SERVER: 13,
  FIREBOARD_WEBVIEW: 15,
  KITCHEN_APP: 14,
};
